'use client'

const SESSION_KEY = 'cm_telemetry_sid'

let memorySid: string | null = null

/**
 * Id PERSISTENTE do navegador (localStorage) — apesar do nome, identifica o
 * visitante, não a visita. As sessões (30 min de inatividade) são recortadas
 * no admin a partir dele: lib/admin/telemetry-queries.ts.
 */
export function getSessionId(): string {
  if (typeof window === 'undefined') return 'ssr'
  try {
    let sid = localStorage.getItem(SESSION_KEY)
    if (!sid) {
      sid = crypto.randomUUID()
      localStorage.setItem(SESSION_KEY, sid)
    }
    return sid
  } catch {
    // Storage bloqueado (modo privado antigo, política do navegador): id só da aba.
    memorySid ??= crypto.randomUUID()
    return memorySid
  }
}
